import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXmarkwithoutborder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 28,
	viewBox: "0 0 29 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28.5 2.82L25.68 0L14.5 11.18L3.32 0L0.5 2.82L11.68 14L0.5 25.18L3.32 28L14.5 16.82L25.68 28L28.5 25.18L17.32 14L28.5 2.82Z",
		fill: "black"
	})
});
export default SvgXmarkwithoutborder;
